<template>
  <div>
    <section
      :class="{ 'border-main p-6 mb-3': !isDrawerUse }"
      class="rounded-2xl"
    >
      <h3 class="text-base font-bold text-root-2 pt-5 pb-2">Card Fees</h3>
      <div class="bg-gray-30 text-sm flex p-4 rounded-lg">
        <p class="text-black-10 font-normal">Total Card Fees</p>
        <p class="text-fg-muted font-bold ml-auto">$5.00</p>
      </div>
    </section>
    <section class="border-main p-6 rounded-2xl mt-4">
      <h3 class="text-base font-bold text-root-2 pt-5 pb-2">Billing Address</h3>
      <div
        class="bg-gray-30 text-sm flex p-4 rounded-lg mb-2.5"
        v-for="(data, index) in mockData"
        :key="index"
      >
        <p class="text-black-10 font-normal">{{ data.title }}</p>
        <p class="text-fg-muted font-bold ml-auto">{{ data.value }}</p>
      </div>
    </section>
    <div class="flex justify-center mt-7">
      <!-- The id in the next line maps the walkthrough to that el-button element. Please do not remove this id -->
      <el-button
        @click="cardCreationSuccessful"
        class="w-full bg-primary cursor-pointer rounded-lg py-4 flex justify-center items-center text-white font-normal"
        id="cardsTourItem3"
      >
        Confirm
      </el-button>
    </div>
    <app-tour
      :tourDetails="cardsTour"
      tourComponent="card"
      :displayTour="displayTour"
      @stopTour="stopTour"
    />
  </div>
</template>

<script>
import { CARDS_TOUR } from '@/utils/constants'
export default {
  props: {
    isDrawerUse: {
      type: Boolean,
      default: () => false
    }
  },
  components: {
    AppTour: () => import('@/components/v2/app-tour/AppTour.vue')
  },
  data () {
    return {
      displaySuccessDialog: false,
      displayTour: false,
      cardsTour: CARDS_TOUR,
      mockData: [
        { title: 'Country', value: 'Nigeria' },
        { title: 'State', value: 'Oyo' },
        { title: 'Address', value: '10 Defi Street, A- 24 Estate' },
        { title: 'Postal Code', value: '100012' }
      ]
    }
  },
  methods: {
    cardCreationSuccessful () {
      this.$emit('cardCreationSuccess')
    },
    stopCardsTourThree () {
      this.$store.dispatch('appTour/startCardsTourThree', false)
    },
    returnToDefaultScreen () {
      this.$store.dispatch('appTour/updateCurrentVirtualCardCreationStep', 1)
      this.$store.dispatch('appTour/updateCardsScreen', 'add-new-card')
    },
    startCardsTour () {
      this.$tours.cardsTour.start(2)
      this.displayTour = true
    },
    stopTour () {
      this.displayTour = false
      this.stopCardsTourThree()
      this.returnToDefaultScreen()
    }
  },
  mounted () {
    if (this.$store.state.appTour.startCardsTourThree) {
      setTimeout(() => {
        this.startCardsTour()
      }, 10)
    }
  }
}
</script>

<style lang="scss" scoped></style>
